<div
  style="visibility: hidden; position: fixed"
  #contextMenuTrigger
  [matMenuTriggerFor]="contextMenu"
  [style.left]="posX + 'px'"
  [style.top]="posY + 'px'"
></div>
<mat-menu #contextMenu="matMenu">
  <ng-container *ngFor="let item of items">
    <ng-container *trakrsuiteHasRole="item.roles">
      <button
        *ngIf="item.show"
        mat-menu-item
        (click)="onClick(item.action, item.id)"
        attr.aria-label="{{ item.text | translate }}"
      >
        <mat-icon>{{ item.icon }}</mat-icon> {{ item.text | translate }}
      </button>
    </ng-container>
  </ng-container>
</mat-menu>
